import { locale } from "./Endpoints"

export const prefix = (l) => {
  return locale(l) === "da" ? "" : "/" + locale(l)
}

export const HOME = () => `${prefix()}/parkering`
export const SEARCH = (l) => `${prefix(l)}/parkering/search`
export const SEARCH_AMMEND_BOOKING = (l) => `${prefix(l)}/parkering/amend-search`
export const RECEIPT = () => `${prefix()}/parkering/receipt`
export const AMMEND_SEARCH = () => `${prefix()}/parkering/manage`
export const AMMEND_CHECKOUT = () => `${prefix()}/parkering/search/amend-checkout`
export const EXTEND_CHECKOUT = () => `${prefix()}/parkering/search/extend-checkout`
export const AMMEND_SHOW_BOOKING = (l) => `${prefix(l)}/parkering/manage/search`
export const AMMEND_EDIT_INFO = () => `${prefix()}/parkering/manage/edit-info`
export const AMMEND_EDIT_TIME = () => `${prefix()}/parkering/manage/edit-time`
export const AMMEND_EXTEND_TIME = () => `${prefix()}/parkering/search/extend-time`
export const AMMEND_CANCELLATION = () => `${prefix()}/parkering/manage/cancel`
export const EXTRA_SERVICES = () => `${prefix()}/parkering/search/extra-services`
export const CHECKOUT = () => `${prefix()}/parkering/search/checkout`
export const NOT_FOUND = () => `${prefix()}/parkering/not-found`

export const ORDER_HISTORY = () => `${prefix()}/min-side/ordre-historik`
